import { render, staticRenderFns } from "./TranscriptionInWordForm.vue?vue&type=template&id=8b607ebe&scoped=true&lang=pug&"
import script from "./TranscriptionInWordForm.vue?vue&type=script&lang=js&"
export * from "./TranscriptionInWordForm.vue?vue&type=script&lang=js&"
import style0 from "./TranscriptionInWordForm.vue?vue&type=style&index=0&id=8b607ebe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b607ebe",
  null
  
)

export default component.exports